import {CountryType} from "../types/CountryType";

export const countries: Array<CountryType> = [
  {
    name: "Sri Lanka",
    key: "LKA"
  }
];
